import "../../styles/Settings.scss";

import React from "react";

import Account from "./Account";
import Appearance from "./Appearance";

const Settings = () => {
    return (
        <>
            <h2 id="settings-title">Settings</h2>
            <div className="settings">
                <div id="settings-nav">
                    <a href="#account">Account</a>
                    <a href="#appearance">Appearance</a>
                </div>

                <div id="settings-content">
                    <Account />
                    <Appearance />
                </div>
            </div>
        </>
    );
};

export default Settings;
